import './index.scss';

const coursework = [
  'Deep Learning',
  'Operating Systems',
  'Computer Architecture',
  'Network Security & Encryption',
  'Cloud Security',
];

const involvement = [
  "Dean's List",
  'Engineering Ambassador',
  'Engineering Society',
];

const Education = () => (
  <section id="education">
    <div className="sec-head reveal">
      <span className="sec-label">04</span>
      <h2 className="sec-title">Education</h2>
    </div>

    <div className="edu-card reveal">
      <div className="edu-card-top">
        <div>
          <div className="edu-degree">Bachelor of Applied Science, Computer Engineering 
          </div>
          <div className="edu-school">University of British Columbia · Kelowna, BC</div>
        </div>
        <div className="edu-meta">
          <span className="edu-period">Expected Graduation: June 2027</span>
        </div>
      </div>
      
      <div className="edu-tag-group">
        {/* <div className="edu-tag-group-label">Involvement</div> */}
        <div className="edu-tags">
          {involvement.map((item) => (
            <span className="highlight-pill green" key={item}>{item}</span>
          ))}
        </div>
      </div>

      <div className="edu-tag-group">
        <div className="edu-tag-group-label">Relevant coursework</div>
        <div className="edu-tags">
          {coursework.map((course) => (
            <span className="skill-tag" key={course}>{course}</span>
          ))}
        </div>
      </div>
      
    </div>
  </section>
);

export default Education;
